/** Watchlist 추천 근거 품질 shadow 요약. */
import { EvidenceSummary } from '../../services/operationsApi';

interface Props {
  summary?: EvidenceSummary;
}

const FLAG_LABEL: Record<string, string> = {
  legacy_evidence_unavailable: '근거 캐시 없음',
  ticker_not_in_news: '뉴스 종목 불일치',
  source_claim_mismatch: '출처 주장 불일치',
  rag_mode_mismatch: 'RAG 모드 불일치',
};

export default function OperationsEvidenceSummary({ summary }: Props) {
  if (!summary) {
    return <p className="op-empty">추천 근거 품질 데이터 없음</p>;
  }

  const flagged = summary.flagged_symbols || [];
  return (
    <div className="op-evidence-panel">
      <div className="op-evidence-metrics">
        <Metric label="평균 근거점수" value={formatScore(summary.average_score)} />
        <Metric label="평가 완료" value={`${summary.scored_count ?? 0}/${summary.recommendations_count ?? 0}`} />
        <Metric label="주의 필요" value={`${summary.low_evidence_count ?? 0}`} tone="warn" />
        <Metric label="High severity" value={`${summary.high_severity_count ?? 0}`} tone="bad" />
        <Metric label="미평가" value={`${summary.not_evaluated_count ?? 0}`} />
      </div>
      <div className="op-evidence-flags">
        {flagged.map((item) => (
          <span key={`${item.symbol}-${item.flags.join('-')}`} className={`severity-${item.severity || 'low'}`}>
            <strong>{item.symbol}</strong>
            {item.flags.map((flag) => FLAG_LABEL[flag] || flag).join(', ')}
          </span>
        ))}
        {flagged.length === 0 && <span>근거 품질 플래그 없음</span>}
      </div>
    </div>
  );
}

function Metric({ label, value, tone }: { label: string; value: string; tone?: string }) {
  return (
    <span className={tone ? `tone-${tone}` : ''}>
      <small>{label}</small>
      <strong>{value}</strong>
    </span>
  );
}

function formatScore(value?: number | null) {
  return value == null ? '-' : `${value.toFixed(1)}/6`;
}
